export const DEFAULT_VISION_MODE = 'local' as const

export const HOSTED_VISION_MODE = 'hosted' as const
